import { toast } from "sonner";
import { residentApi, errMsg } from "@/lib/api";
import { useResidentApi } from "@/pages/resident/useResidentApi";

export function useShortlist() {
  const { data, loading, error, reload } = useResidentApi<any[]>("/resident/shortlist");
  const ids = new Set((data || []).map((r) => r.id));
  const toggle = async (roomId: string) => {
    const saved = ids.has(roomId);
    try {
      if (saved) await residentApi.delete(`/resident/shortlist/${roomId}`);
      else await residentApi.post("/resident/shortlist", { room_id: roomId });
      toast.success(saved ? "Removed from Saved" : "Saved to your shortlist");
      reload();
    } catch (e) { toast.error(errMsg(e)); }
  };
  return { rooms: data, loading, error, reload, ids, toggle };
}
